module.exports = __webpack_public_path__ + "static/img/login_title.07d9451.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_title.png
// module id = ZeET
// module chunks = 8